const config_prod = {
  mojAccountService: "http://moj-account-service.moj.internal",
  videoFeedServiceUrl:
    "http://feed-aggregator-service-mum.moj.internal/feed-aggregator-service/v1",
  apiUrl: "https://moj-apis.sharechat.com",
  apiUrlSharechat: "https://apis.sharechat.com",
  eventsServiceUrl: "https://moj-events-apis.sharechat.com",
  postServiceUrl: "http://post-rendering-service.moj.internal",
  composeServiceUrl: "http://compose-service-v2.moj.internal",
  liveStreamShareServiceUrl: "http://livestream-share-service.moj.internal",
  tagServiceUrl: "http://tag-service.moj.internal",
  exploreServiceUrl: "http://explore-service.moj.internal",
  profileRenderingServiceUrl: "http://profile-rendering-service.moj.internal",
  audioFeedServiceUrl: "http://audio-feed-service.moj.internal",
  creatorMonetizationServiceUrl:
    "http://creator-monetization-tools-service.moj.internal",
  sanityApiUrl:
    "https://s0gyb1xi.apicdn.sanity.io/v1/graphql/production/default",
  sanityUpdateApiUrl:
    "https://s0gyb1xi.api.sanity.io/v1/data/mutate/production",
  mojforcreators: "https://creators.mojapp.in",
  takatakServiceUrl: "http://mx-moj-mapping-service.moj.internal",
  adsTxtJsonStore:
    "http://moj-tools-service.moj.internal/moj-tools-service/v1/jsonStore/bins/mojAdsTxt",
  mqttOptions: {
    port: 8085,
    hostname: "livestream-emqx-sub.mojapp.in",
    path: "/mqtt",
    keepalive: 30,
    protocolId: "MQTT",
    protocolVersion: 4,
    clean: true,
    reconnectPeriod: 1000,
    connectTimeout: 15 * 1000,
    rejectUnauthorized: false,
  },
  siteDomain: "https://mojapp.in",
  downloadAppUrl: "https://links.mojapp.in/p9tW/eda71714",
  liveStreamVgServiceUrl:
    "https://moj-apis.sharechat.com/livestream-vg-service/public/v2",
  experimentationService:
    "http://e13n-lookup-service.moj.internal/e13n-lookup-service/v4.0.0/fetchVariant",
  experimentsList: [
    {
      expName: "moj_sentry_v3",
      expId: "2c7c7b33-c97a-4a5e-8799-e9b98bcb9cce",
    },
  ],
};
export default config_prod;
